import { render, staticRenderFns } from "./AppSearch.vue?vue&type=template&id=9ca45b8c&"
import script from "./AppSearch.vue?vue&type=script&lang=js&"
export * from "./AppSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports